<button *ngIf="options.closeButton" type="button" (click)="remove()" class="toast-close-button" aria-label="Close"></button>

<div *ngIf="title" [class]="options.titleClass" [attr.aria-label]="title">
    {{ title }}
</div>

<div *ngIf="message && options.enableHtml" role="alert" [class]="options.messageClass" [innerHTML]="message"></div>

<div *ngIf="message && !options.enableHtml" role="alert" [class]="options.messageClass"
    [attr.aria-label]="message"
>
    {{ message }}
</div>

<button *ngIf="options.payload?.viewMoreAction" type="button" 
    class="btn btn-link btn-toast-btn-link" 
    (click)="options.payload?.viewMoreAction()"
>
    {{ 'common.viewMore' | translate | titlecase }}
</button>
